// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleHeader-module--container--YTYco","header":"ArticleHeader-module--header--2f5Ab"};